<h1>{{ 'checkout.payment_error' | translate }}</h1>
<p>{{ 'checkout.error_with_payment' | translate }}</p>

<div class="ibe-retry-payment-button">
    <a routerLink="/checkout/payment" class="ibe-btn ibe-primary-btn">
        {{ 'checkout.payment_retry' | translate }}
    </a>
</div>
